import styled from "styled-components";

export const RemoveAnchorUnderline = styled.div`
  a {
    text-decoration: none !important;
  }
  
`;
